import React, { useState, useEffect } from "react";
import { Box, Typography, Grid, Skeleton } from "@mui/material";
import { Elevator, Build, Security } from "@mui/icons-material";
import axiosInstance from "../../../utils/axiosConfig";

const iconMap = {
  Elevator: Elevator,
  Build: Build,
  Security: Security
};

function Services() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchServices();
  }, []);

  const fetchServices = async () => {
    try {
      const response = await axiosInstance.get('/service_offerings?offering_type=service');
      setServices(response.data);
    } catch (error) {
      console.error("Error fetching services:", error);
    } finally {
      setLoading(false);
    }
  };

  const renderIcon = (iconName) => {
    const IconComponent = iconMap[iconName];
    return IconComponent ? (
      <IconComponent sx={{ fontSize: 60, color: "#FFC107" }} />
    ) : null;
  };

  const renderSkeletons = () => (
    <>
      {[1, 2, 3].map((item) => (
        <Grid item xs={12} sm={6} md={4} key={item}>
          <Box
            sx={{
              textAlign: "center",
              p: 3,
              border: "1px solid #FFC107",
              borderRadius: "8px",
              height: "280px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            <Skeleton variant="circular" width={60} height={60} />
            <Skeleton variant="text" sx={{ mt: 2, width: "80%", height: 64 }} />
            <Skeleton variant="text" sx={{ mt: 1, width: "100%", flex: 1 }} />
          </Box>
        </Grid>
      ))}
    </>
  );

  return (
    <Box sx={{ py: 5, backgroundColor: "#FFF8E1" }}>
      <Typography
        variant="h4"
        sx={{ textAlign: "center", color: "#212121", mb: 3 }}
      >
        Nuestros Servicios
      </Typography>
      <Grid container spacing={4} sx={{ px: 3 }}>
        {loading ? renderSkeletons() : services.map((service) => (
          <Grid item xs={12} sm={6} md={4} key={service.id}>
            <Box
              sx={{
                textAlign: "center",
                p: 3,
                border: "1px solid #FFC107",
                borderRadius: "8px",
                transition: "transform 0.3s",
                height: "280px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start",
                ":hover": {
                  transform: "scale(1.05)",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
                },
              }}
            >
              {renderIcon(service.icon_name)}
              <Typography
                variant="h6"
                sx={{
                  mt: 2,
                  color: "#212121",
                  fontWeight: "bold",
                  minHeight: "64px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {service.title}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  mt: 1,
                  color: "#616161",
                  fontSize: "0.95rem",
                  flex: 1,
                }}
              >
                {service.description}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default Services;
